//Hooks
import { ClientHookOptions, useVahakMutationQuery, useVahakQuery } from "@vahak/core/dist/hooks/useVahakQueryClient";

import useVahakHttpClient from "@vahak/core/dist/hooks/useVahakHttpClient";

// services
import { QueryNames } from "@vahak/core/dist/_services/hooks/queryNames";

//Endpoints
import API from "@vahak/core/dist/_services/const";

// types
import { ApiErrorResponseType } from "@vahak/core/dist/custom-types/api-error-response-type";
import { DocumentReferenceType, DocumentType } from "../../types/document";
import { TicketDocument } from "../../components/admin/ticket-system-helper/constants";

/**
 * !!!IMPORTANT!!!
 *
 * reference_type   DB Purpose    reference_id
 *      1               Load        <load id>
 *      2               Lorry       <lorry id>
 *      3              Company      <company id>
 */

type NameValuePair = {
    name: string;
    url: string;
};

interface UploadDocumentsRequestBody {
    reference_type?: DocumentReferenceType;
    employee_id?: number;
    reference_id?: number;
    ticket_id?: number;
    document_type: DocumentType | TicketDocument;
    company_id: number;
    payload: {
        fields?: NameValuePair[];
        documents?: NameValuePair[];
    };
    keep_lorry_intransit?: boolean;
    is_reupload?: boolean;
}

interface UploadDocumentsResponse {
    data: {
        ticket_id: number;
        message: string;
        ticket_status: number;
    };
}

export const usePostDocuments = () => {
    const { POST } = useVahakHttpClient();

    const getDocuments = (data: UploadDocumentsRequestBody) => {
        return POST<UploadDocumentsRequestBody, UploadDocumentsResponse>(API.UPLOAD_DOCUMENTS, {
            ...data
        });
    };

    return useVahakMutationQuery<UploadDocumentsResponse, ApiErrorResponseType, UploadDocumentsRequestBody>(
        [QueryNames.getDocuments],
        getDocuments
    );
};

/**
 *
 * @param options
 * @param params
 * @returns
 *
 * Experimental purpose, POST query without mutation
 * So we can invalidate the query
 */
export const useUploadDocumentsNonMutate = (
    options: ClientHookOptions<UploadDocumentsResponse>,
    params: UploadDocumentsRequestBody
) => {
    const { company_id, document_type, payload, reference_id, reference_type, ticket_id } = params;
    const { POST } = useVahakHttpClient();
    const getDocuments = () => {
        return POST<UploadDocumentsRequestBody, UploadDocumentsResponse>(API.GET_DOCUMENTS, {
            company_id,
            document_type,
            payload,
            reference_id,
            reference_type,
            ticket_id
        });
    };

    return useVahakQuery<UploadDocumentsResponse, unknown>([QueryNames.getDocumentsNonMutate], getDocuments, options);
};
